module.exports = __webpack_public_path__ + "img/logo48.4c586a11.png";